export class CabinClassTravelers {
    public cabinClass: string;
    public travelers: Travalers;

    constructor() {
        this.cabinClass = 'Economy';
        this.travelers = {
            adults: 1,
            childrens: 0,
            infants: 0,
        }
    }
}

export interface Travalers {
    adults: number;
    childrens: number;
    infants: number;
}